import { Heading, Icon, Paragraph, Popover } from '@zillow/constellation-10';
import { IconQuestionMarkCircleOutline } from '@zillow/constellation-icons';
import type { ReactNode } from 'react';

export const ColumnHeaderHelp = ({ title, body }: { title: string; body: ReactNode }) => (
  <Popover
    modal={false}
    trigger={
      <Icon css={{ color: 'icon.subtle', cursor: 'pointer' }} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <IconQuestionMarkCircleOutline />
      </Icon>
    }
    header={<Heading level={6}>{title}</Heading>}
    body={<Paragraph>{body}</Paragraph>}
  />
);
